import React from "react";
import get from "lodash/get";
import { wrapCollectionLayout } from "@quintype/components";
import { Link, ResponsiveHeroImage, LoadMoreButton, LazyLoadImages } from "@quintype/components";
import "./four-col-grid.module.css";
import { ReviewRating } from "@quintype/components";
import { ImageFallback } from "../basic/image-fallback.js";
import { collectionColor, collectionSection } from "./collection-layout-helper";
import { altTagOfHeroImages, isExternalStory } from "../../utils";
import { CollectionName } from "../basic/collection-name.js";

const themeStyles = {
  dark: "theme-dark"
};

function FourColGridBase({ collection, stories, associatedMetadata, config, onLoadMore, noMoreStories }) {
  const {
    theme = "dark",
    hide_section = false,
    enable_load_more_button = false,
    show_collection_title: collectionName = true,
    limit_stories = 0
  } = associatedMetadata;

  if (limit_stories) stories = stories.slice(0, limit_stories);

  return (
    <div className="component-wrapper" data-test-id="four-col-grid">
      {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
      <div styleName="stories" data-test-id="stories">
        {stories.map((story, index) => {
          const isReviewStory = story["story-template"] === "review";
          return (
            <div key={`${index}-${story.id}`}>
              <Link href={`/${story.slug}`} externalLink={isExternalStory(story)}>
                {story["hero-image-s3-key"] ? (
                  <figure styleName={`image ${story["story-template"] === "video" ? "video" : ""}`}>
                    <LazyLoadImages margin={"0px"}>
                      <ResponsiveHeroImage
                        story={story}
                        aspectRatio={[16, 9]}
                        alt={altTagOfHeroImages(story)}
                        defaultWidth={480}
                        widths={[250, 480, 640]}
                        sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
                        imgParams={{ auto: ["format", "compress"], fit: "max" }}
                      />
                    </LazyLoadImages>
                  </figure>
                ) : (
                  <ImageFallback className="story-card__image story-card__image--cover" />
                )}
                <div styleName="relative">
                  {!hide_section && (
                    <div styleName="section-name" data-test-id="four-col-grid-section-name">
                      {story.sections[0]["display-name"] || story.sections[0]["name"]}
                    </div>
                  )}
                  <h2 styleName={`headline ${themeStyles[theme] || ""}`} data-test-id="four-col-grid-headline">
                    <bdi dangerouslySetInnerHTML={{ __html: story.headline }} />
                    {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
                  </h2>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
      {(associatedMetadata ? associatedMetadata.enable_load_more_button === true : true) && !noMoreStories && (
        <LoadMoreButton className="load-more-button" onLoadMore={onLoadMore} text="Load More" />
      )}
    </div>
  );
}

export const FourColGrid = wrapCollectionLayout(FourColGridBase);
